var Pium = Pium  || {}
Pium['WLWishList'] = {
  init() {
    function swymCallbackFn(swat) {
      window._swat.fetch(function (r) {
        let hearts = document.querySelectorAll('.js-add-wishlist')
        let count = document.querySelectorAll('[data-wishlist-count]')
        function fetchWishListItems(r) {
          let ids = ''
          for(let item of r) {
            if(ids !== '') {
              ids = ids + `+OR+id:${item.empi}`
            } else {
              ids = `id:${item.empi}`
            }
          }
          fetch(`/search?view=product_info&q=${ids}`)
            .then((response) => response.json())
            .then((res) => {
              const matchingVariants = r.map((item, index) => {
                const product = res?.filter((e) => e.product_id == item.empi);
                const matchingVariantsForItem = product[0]?.product_data?.variants?.find((variant) => variant.id == item.epi);
                return matchingVariantsForItem ? matchingVariantsForItem : null;
              }).filter(Boolean);
              count.forEach((cnt) => {
                cnt.innerHTML = matchingVariants.length
                if (matchingVariants.length === 0) {
                  cnt.style.display = 'none';
                } else {
                  cnt.style.display = 'flex';
                }
              })
            })
            .catch((error) => {
              console.error('Fetch error:', error);
            });
        }
        fetchWishListItems(r);
        hearts.forEach((heart) => {
          if(!r.find(e => e.epi == heart.dataset.variantId)) {
            heart.classList.remove('active')
          } else {
            heart.classList.add('active')
          }
        })
        // count.forEach((cnt) => {
        //   cnt.innerHTML = r.length
        // })
      });
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  },
  action() {
    let wishlistButtons = document.querySelectorAll('.js-add-wishlist')
    wishlistButtons.forEach((wishlistButton) => {
      wishlistButton.addEventListener('click', (evt) => {
        function swymCallbackFn(swat) {
          window._swat.fetch(function (r) {
            if(evt.target.classList.contains('active')) {
              r.map((res) => {
                if (parseInt(res.epi) === parseInt(evt.target.dataset.variantId)) {
                  const pid = {
                    "epi": res.epi,
                    "du": res.du,
                    "empi": res.empi,
                  }
                  window.SwymCallbacks.push((swat) => {
                    swat.removeFromWishList(pid, (list) => {
                      let hearts = document.querySelectorAll('.js-add-wishlist')
                      evt.target.classList.remove('active')
                      // hearts.forEach((heart) => {
                      //   heart.classList.remove('active')
                      // })
                    }, (xhrObj) => {
                      alert('お気に入りリストの削除に失敗しました。')
                    });
                  })
                  let count = document.querySelectorAll('[data-wishlist-count]')
                  
                  function fetchWishListItemsRemove(r) {
                    let ids = ''
                    for(let item of r) {
                      if(ids !== '') {
                        ids = ids + `+OR+id:${item.empi}`
                      } else {
                        ids = `id:${item.empi}`
                      }
                    }
                    fetch(`/search?view=product_info&q=${ids}`)
                      .then((response) => response.json())
                      .then((res) => {
                        const matchingVariants = r.map((item, index) => {
                          const product = res?.filter((e) => e.product_id == item.empi);
                          const matchingVariantsForItem = product[0]?.product_data?.variants?.find((variant) => variant.id == item.epi);
                          return matchingVariantsForItem ? matchingVariantsForItem : null;
                        }).filter(Boolean);
                        count.forEach((cnt) => {
                          if (matchingVariants.length - 1 === 0) {
                            cnt.style.display = 'none';
                          } else {
                            cnt.style.display = 'flex';
                          }
                          cnt.innerHTML = matchingVariants.length - 1
                        })
                      })
                      .catch((error) => {
                        console.error('Fetch error:', error);
                      });
                  }
                  fetchWishListItemsRemove(r);
                  // count.forEach((cnt) => {
                  //   cnt.innerHTML = r.length - 1
                  // })
                  
                }
              })
            } else {
              window._swat.addToWishList(
                {
                  "epi": evt.target.dataset.variantId,
                  "du":  `${location.origin}/products/${encodeURI(evt.target.dataset.productHandle)}?variant=${evt.target.dataset.variantId}`,
                  "empi": evt.target.dataset.productId,
                  "iu": evt.target.dataset.src,
                  "pr": evt.target.dataset.variantPrice,
                },
                function (r) {
                  let hearts = document.querySelectorAll('.js-add-wishlist')
                  evt.target.classList.add('active')
                  // hearts.forEach((heart) => {
                  //   heart.classList.add('active')
                  // })
                }
              );
              let count = document.querySelectorAll('[data-wishlist-count]')
              function fetchWishListItemsAdd(r) {
                let ids = ''
                for(let item of r) {
                  if(ids !== '') {
                    console.log('item.empi', item.empi)
                    ids = ids + `+OR+id:${item.empi}`
                  } else {
                    ids = `id:${item.empi}`
                  }
                }
                fetch(`/search?view=product_info&q=${ids}`)
                  .then((response) => response.json())
                  .then((res) => {
                    const matchingVariants = r.map((item, index) => {
                      const product = res?.filter((e) => e.product_id == item.empi);
                      const matchingVariantsForItem = product[0]?.product_data?.variants?.find((variant) => variant.id == item.epi);
                      return matchingVariantsForItem ? matchingVariantsForItem : null;
                    }).filter(Boolean);
                    count.forEach((cnt) => {
                      cnt.style.display = 'flex';
                      cnt.innerHTML = matchingVariants.length + 1
                    })
                  })
                  .catch((error) => {
                    console.error('Fetch error:', error);
                  });
              }
              fetchWishListItemsAdd(r);
              // count.forEach((cnt) => {
              //   console.log("これか！！！！")
              //   cnt.innerHTML = r.length + 1
              // })
            }
          });
        }
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }
        console.log(window.SwymCallbacks)
        window.SwymCallbacks.push(swymCallbackFn);
      })
    })
  },
  listObserver() {
    const target = document.querySelector('#swym-wishlist-render-container');
    if(target) {
      const observer = new MutationObserver(() => {
        const targets = document.querySelectorAll('.swym-delete-btn')
        targets.forEach(target => {
          target.addEventListener('click', () => {
            let count = document.querySelectorAll('[data-wishlist-count]')
            count.forEach((cnt) => {
              cnt.innerHTML = document.querySelectorAll('.swym-wishlist-item').length - 1
            })
          })
        })
      });

      // 監視を開始
      observer.observe(target, {
        attributes: true, // 属性変化の監視
        childList: true, // 子ノードの変化を監視
        subtree: true // 子孫ノードも監視対象に含める
      });
    }
  }
}